import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { TrackingCaseEditForm } from "application/tracking-case/forms";
import { TrackingCaseService, CaseStatusService } from "application/tracking-case/services";
import { LocalPatientService } from "application/patient/services";
import { FacilityService } from 'application/facility/services';
import {ProductService, ItemCategoryService} from 'application/product/services';
import { observable, action } from "mobx";
import {InsuranceService} from 'application/import/services';

class TrackingCaseEditViewStore extends BaseEditViewStore {
	@observable accessor itemCategory = null;
	params = {
		id: this.rootStore.routerStore.routerState.params.id,
	};

	constructor(rootStore) {
        const service = new TrackingCaseService(rootStore.application.baasic.apiClient);
        const localPatientService = new LocalPatientService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const itemCategoryService = new ItemCategoryService(rootStore.application.baasic.apiClient);
        const productService = new ProductService(rootStore.application.baasic.apiClient);

        const id = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
			name: "tracking-case",
			id: id,
			actions: {
				get: async id => {
					const response = await service.get(id,{embed:"TrackingCaseProducts,Facility,Patient,ItemCategory,CaseStatus"});
					response.data.trackingCaseProducts = response.data.trackingCaseProducts && response.data.trackingCaseProducts.map(i=> i.product);
					response.data.payorSource = response.data.payorSource === 0 ? "" : response.data.payorSource;
					this.form.update(response.data);

					return response.data;
				},
				update: async resource => {
					resource.trackingCaseProducts = resource.trackingCaseProducts && resource.trackingCaseProducts.map(i=> { return { productId: i.id }});
					const response = await service.update(resource);
					return response.data;
				},
				create: async resource => {
					resource.trackingCaseProducts = resource.trackingCaseProducts && resource.trackingCaseProducts.map(i=> { return { productId: i.id }});
					const response = await service.create(resource);
					return response.data;
				},
			},
			errorActions: {
				onCreateError: ({ error }) => {
					rootStore.notificationStore.error('TRACKING_CASE.CREATE.ERROR', error);
				},
				onUpdateError: ({ error }) => {
					rootStore.notificationStore.error('TRACKING_CASE.EDIT.ERROR', error);
				},
			},
			FormClass: TrackingCaseEditForm,
		});

        if(!this.isEdit){
            this.form.$('validFrom').value = new Date();
		}

        this.service = new TrackingCaseService(rootStore.application.baasic.apiClient);
        this.caseStatusService = new CaseStatusService(rootStore.application.baasic.apiClient);
        this.insuranceService = new InsuranceService(rootStore.application.baasic.apiClient);

        this.facilityStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await facilityService.find({ searchQuery: term, rpp: 10, inActive: false });
                return response.data.item;
            }
        });

        this.itemCategoryStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async(term) => {
				const response = await itemCategoryService.find({ 
					searchQuery: term, 
					rpp: 100
				});
				return response.data.item;
			},
			onChange: async (item) => {
				this.itemCategory = item;
				this.productStore.filterAsync();
				this.form.$("trackingCaseProducts").value = "";
				this.productStore.setValue([]);
			}
		});

        this.caseStatusStore = new BaasicDropdownStore({
			filterable: false
		}, {
			fetchFunc: async(term) => {
				const response = await this.caseStatusService.lookup({ searchQuery: term });
				return response.item;
			}
		});

        this.localPatientStore = new BaasicDropdownStore({
			filterable: true,
			textField:"name",
		}, {
			fetchFunc: async(term) => {
				const response = await localPatientService.find({ 
					sort:"lastName|asc",
					searchQuery: term, 
					rpp: 100
					});
				
				return response.data.item.map(item=>{
					return {
						name: `${item.lastName}, ${item.firstName}`,
						...item
					}	
				});
			},
		});

        this.insuranceCompanyStore = new BaasicDropdownStore({
				textField: 'insuranceName',
				dataItemKey: 'insuranceId',
				filterable: true            
			}, {
			fetchFunc: async (term) => {
				const response = await this.insuranceService.find({ searchQuery: term });
				return response.data.item;
			},
		});

        this.productStore = new BaasicDropdownStore({
			filterable: true,
			multi:true,
			textField:"itemId",
		}, {
			fetchFunc: async(term) => {
				const response = await productService.find({ 
					sort:"itemId|asc",
					searchQuery: term, 
					rpp: 100,
					isActive: true,
					itemCategoryId: this.itemCategory
				});
				return response.data.item;
			}
		});

        if(this.isEdit){
			this.form.$("caseStatusId").set("rules", "required|string");
		}
    }

	@action
	setItem(item) {
        this.item = item;
        this.itemInitialized = true;

		this.facilityStore.setValue(item.facility);
		this.itemCategoryStore.setValue(item.itemCategory);
		this.caseStatusStore.setValue(item.caseStatus);
		this.localPatientStore.setValue({
			name: `${item.patient.lastName}, ${item.patient.firstName}`,
			...item.patient
		});
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('TRACKING_CASE.CREATE.SUCCESS');
    }
    
    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('TRACKING_CASE.EDIT.SUCCESS', name);
    }
}

export default TrackingCaseEditViewStore;
